// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import styled from '@emotion/styled';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import isPropValid from '@emotion/is-prop-valid';
import * as ReactRouterDOM from 'react-router-dom';
const useHistoryHook = 'useHistory';
const useNavigateHook = 'useNavigate';
// Member Web uses React Router v5, which does not have the `useNavigate` API
const isReactRouter6API = useNavigateHook in ReactRouterDOM;
/**
 * This hook mirrors the `useNavigate` in React Router v6
 * using the v5 API
 */
function useNavigateV5() {
    // @ts-expect-error v5 API
    const history = ReactRouterDOM[useHistoryHook]();
    return (to, { replace = false, state } = {}) => {
        const path = typeof to === 'object' ? { ...to, ...(state ? { state } : {}) } : to;
        if (replace) {
            history.replace(path);
        }
        else {
            history.push(path);
        }
    };
}
const useNavigate = isReactRouter6API
    ? ReactRouterDOM[useNavigateHook]
    : useNavigateV5;
/**
 * @deprecated Use {@link Link}
 */
const EmotionLink = styled(ReactRouterDOM.Link, {
    // <Link> components forward all unknown properties to the underlying <a>,
    // not knowing this Emotion will cause React DOM errors so be explicit
    // about our supported properties.
    shouldForwardProp: propName => propName === 'className' ||
        propName === 'to' ||
        (isReactRouter6API && propName === 'state') ||
        propName === 'replace' ||
        propName === 'data-testid' ||
        propName === 'style' ||
        propName === 'children' ||
        propName === 'tabIndex' ||
        propName === 'onKeyUp' ||
        propName === 'role' ||
        isPropValid(propName),
})({
    cursor: 'pointer',
});
export { EmotionLink as DeprecatedReactRouterLink, useNavigate, isReactRouter6API, };
